import { render, staticRenderFns } from "./BrightReportContent.vue?vue&type=template&id=2062670b"
import script from "./BrightReportContent.vue?vue&type=script&lang=js"
export * from "./BrightReportContent.vue?vue&type=script&lang=js"
import style0 from "./BrightReportContent.vue?vue&type=style&index=0&id=2062670b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports